import { render } from "./final-gaji-list-draft.vue?vue&type=template&id=a055102e"
import script from "./final-gaji-list-draft.vue?vue&type=script&lang=js"
export * from "./final-gaji-list-draft.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__